export const DefaultConstConfig = {
    // defaultCountryDetails: {
    //     "localizationName": 'USD',
    //     "dialCode": "+1",
    //     "mask": "999-999-9999",
    // },
    // maxMakeSelection: 10,
    // maxToleranceRange: 150,
    // maxPricingLength: 4,
    // maxPricingRange: 999.99,
    // maxLatitudeLongitudeLength: 40,
    // logoDocMaxSize: 10485760, //10MB (Bytes)
    // countyDocMaxSize: 5242880, //5MB (Bytes),
    parcelNumber: {
        formate: '99-99-99.9-999-999-999.999',
        regEx: /^\d{2}\-\d{2}\-\d{2}\.\d{1}\-\d{3}\-\d{3}\-\d{3}\.\d{3}$/,
        string: '__-__-__._-___-___-___.___'
    },
    documentationInternalPreviewUrl: "/documentations-portal/internal/view",
}

export enum EnvTypeEnum {
    Production = 1,
    Staging = 2,
    Development = 3
}